import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const AccountDialog = ({ open, onOpenChange, initial, onSave }) => {
  const [f, setF] = useState({});
  useEffect(() => { if (open) setF({ site_name: "", user_code: "", ...initial }); }, [open, initial]);
  const valid = f.site_name?.trim() && f.user_code?.trim();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="account-form-dialog" className="sm:max-w-sm" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="font-head text-2xl">{initial?.id ? "Edit site" : "Add site to group"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={(e) => { e.preventDefault(); if (valid) onSave(f); }} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Site name</Label>
            <Input data-testid="account-site-input" autoFocus value={f.site_name || ""} onChange={(e) => setF({ ...f, site_name: e.target.value })} />
          </div>
          <div className="space-y-1.5">
            <Label>User ID</Label>
            <Input data-testid="account-userid-input" value={f.user_code || ""} onChange={(e) => setF({ ...f, user_code: e.target.value })} />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={!valid} className="bg-sky-600 hover:bg-sky-700" data-testid="account-save-btn">Save</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
